import React from 'react';
import { Switch } from 'react-router-dom';
import CotizadorMoto from './pages/CotizadorMoto/CotizadorMoto';
import EmisionMoto from './pages/EmisionMoto/EmisionMoto';
import ResumenMoto from './pages/ResumenMoto/ResumenMoto';
import FacturacionMoto from './pages/FacturacionMoto/FacturacionMoto';

const MotosRoutes = ({ ProtectedRouteLogin, HomePublicaLayout, userIsLoggedIn, match }) => {
  return (
    <Switch>
      <ProtectedRouteLogin
        exact={true}
        path='/motos/cotizar'
        loggedIn={userIsLoggedIn}
        component={CotizadorMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/motos/emision'
        loggedIn={userIsLoggedIn}
        component={EmisionMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/motos/resumen'
        loggedIn={userIsLoggedIn}
        component={ResumenMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/motos/facturacion'
        loggedIn={userIsLoggedIn}
        component={FacturacionMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/motos/confirmacion'
        loggedIn={userIsLoggedIn}
        component={FacturacionMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/motos'
        loggedIn={userIsLoggedIn}
        component={CotizadorMoto}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
    </Switch>
  );
};

export default MotosRoutes;
